import React from 'react';
import { ActionButton } from './Forms/ActionButton';

const ConfirmationModal = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = "Confirm Action", 
    message = "Are you sure you want to proceed?", 
    confirmText = "Confirm", 
    cancelText = "Cancel",
    isLoading = false,
    variant = "danger" // danger, warning, info
}) => {
    if (!isOpen) return null;

    const getVariantClasses = () => {
        switch (variant) {
            case 'danger':
                return 'border-red text-red';
            case 'warning':
                return 'border-chipYellow text-yellow-600';
            case 'info':
                return 'border-chipBlue text-blue-600';
            default:
                return 'border-red text-red';
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md mx-4 relative">
                {/* Close button */}
                <button 
                    className="absolute top-3 right-3 text-secondary hover:text-gray-700 text-xl"
                    onClick={onClose}
                    disabled={isLoading}
                >
                    &times;
                </button>

                {/* Modal content */}
                <div className="mb-6">
                    <h3 className={`text-lg font-semibold mb-3 ${getVariantClasses()}`}>
                        {title}
                    </h3>
                    <p className="text-gray-600">
                        {message}
                    </p>
                </div>

                {/* Action buttons */}
                <div className="flex gap-3 justify-end">
                    <ActionButton
                        text={cancelText}
                        variant="secondary"
                        onClick={onClose}
                        disabled={isLoading}
                        type="button"
                    />
                    <ActionButton
                        text={isLoading ? 'Processing...' : confirmText}
                        variant={variant === 'danger' ? 'danger' : 'primary'}
                        onClick={onConfirm}
                        disabled={isLoading}
                        type="button"
                    />
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
